@let deadlineTime = pointData()?.deadlineTime;
@if (deadlineTime && currentPoint() && deadlineSubheading(); as subheading) {
  @let isPast = CommonHelper.isPast(deadlineTime);
  <div class="subheading">
    @if (isPast) {
      <onyx-icon
        name="error-filled"
        [size]="20"
        [onyxTooltip]="`${I18N}.timeToStartHasPassed`"
        [onyxTooltipDisabled]="!!missingAssignment()"
      ></onyx-icon>
    }

    <p [class.f-danger]="isPast" class="deadline">
      <span>{{ subheading | translate }}:</span>

      {{ deadlineTime | onyxDate: 'time-date' : { separator: ' · ' } }}
    </p>
  </div>
}
